import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
export const HighlightedProductsHeaderConfig = {
  ['MARKETING']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.marketing',
      productLevelTitle: 'merchCards.freeCard.productLevelTitle'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.marketing',
      subtitle: 'merchCards.starterCard.description.marketing',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlusInbound25',
      productLevelTitle: 'merchCards.starterCard.title.productLevelTitle'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.marketing',
      subtitle: 'merchCards.professionalCard.description.marketing',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketing.professional.lowerTierPlus',
      productLevelTitle: 'merchCards.professionalCard.title.productLevelTitle'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.marketing',
      subtitle: 'merchCards.enterpriseCard.description.marketing',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketing.enterprise.lowerTierPlus',
      productLevelTitle: 'merchCards.enterpriseCard.title.productLevelTitle'
    }
  },
  ['SALES']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.sales'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.sales',
      subtitle: 'merchCards.starterCard.description.sales',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlusInbound25',
      productLevelTitle: 'merchCards.starterCard.title.productLevelTitle'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.sales',
      subtitle: 'merchCards.professionalCard.description.sales',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.sales.professional.lowerTierPlus',
      productLevelTitle: 'merchCards.professionalCard.title.productLevelTitle'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.sales',
      subtitle: 'merchCards.enterpriseCard.description.sales',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.sales.enterprise.lowerTierPlus',
      productLevelTitle: 'merchCards.enterpriseCard.title.productLevelTitle'
    }
  },
  ['SERVICE']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.service'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.service',
      subtitle: 'merchCards.starterCard.description.service',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlusInbound25',
      productLevelTitle: 'merchCards.starterCard.title.productLevelTitle'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.service',
      subtitle: 'merchCards.professionalCard.description.service',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.professional.lowerTierPlus',
      productLevelTitle: 'merchCards.professionalCard.title.productLevelTitle'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.service',
      subtitle: 'merchCards.enterpriseCard.description.service',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.enterprise.lowerTierPlus',
      productLevelTitle: 'merchCards.enterpriseCard.title.productLevelTitle'
    }
  },
  ['CMS']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.cms'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.cms',
      subtitle: 'merchCards.starterCard.description.cms',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.includes',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlusInbound25',
      productLevelTitle: 'merchCards.starterCard.title.productLevelTitle'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.cms',
      subtitle: 'merchCards.professionalCard.description.cms',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.content.professional.lowerTierPlus',
      productLevelTitle: 'merchCards.professionalCard.title.productLevelTitle'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.cms',
      subtitle: 'merchCards.enterpriseCard.description.cms',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.content.enterprise.lowerTierPlus',
      productLevelTitle: 'merchCards.enterpriseCard.title.productLevelTitle'
    }
  },
  ['OPERATIONS']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.operations'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.operations',
      subtitle: 'merchCards.starterCard.description.operations',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlusInbound25',
      productLevelTitle: 'merchCards.starterCard.title.productLevelTitle'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.operations',
      subtitle: 'merchCards.professionalCard.description.operations',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.professional.lowerTierPlus',
      productLevelTitle: 'merchCards.professionalCard.title.productLevelTitle'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.operations',
      subtitle: 'merchCards.enterpriseCard.description.operations',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.enterprise.lowerTierPlus',
      productLevelTitle: 'merchCards.enterpriseCard.title.productLevelTitle'
    }
  },
  ['COMMERCE']: {
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.commerce',
      subtitle: 'merchCards.professionalCard.description.commerce',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.commerce.professional.lowerTierPlus',
      productLevelTitle: 'merchCards.professionalCard.title.productLevelTitle'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.commerce',
      subtitle: 'merchCards.enterpriseCard.description.commerce',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus',
      lowerTierPlusInbound25: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.commerce.enterprise.lowerTierPlus',
      productLevelTitle: 'merchCards.enterpriseCard.title.productLevelTitle'
    }
  }
};